import { RVUPeriod } from '~/types/hlx/enums';

export const COMPENSATION_TYPE_OPTIONS = [
  { label: 'Hourly ($/hour)', value: 'HOUR' },
  { label: 'Per Shift ($/shift)', value: 'SHIFT' },
  { label: 'RVU Based ($/RVU)', value: 'RVU' },
];

export const RVU_PERIOD_OPTIONS = [
  { label: 'Year', value: RVUPeriod.YEAR },
  { label: 'Shift', value: RVUPeriod.SHIFT },
  { label: 'Hour', value: RVUPeriod.HOUR },
];

export const emptyCompensationForm = {
  compType: COMPENSATION_TYPE_OPTIONS[0],
  laborReqType: null,
  pricePerHour: null,
  pricePerShift: null,
  pricePerRvu: null,
  rvusPerPeriod: null,
  rvuPeriod: RVU_PERIOD_OPTIONS[0],
};
